var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs"),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: false,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("form.oddNumbers"),
                          prop: "queryCode",
                        },
                      },
                      [
                        _c("BjInputCode", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockEntryInform.header.queryCodeText"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.queryCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "queryCode", $$v)
                            },
                            expression: "queryParams.queryCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channelTypeCode", "storeIdList"],
                    "store-option-value": "id",
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockEntryInform.header.status"
                          ),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: { "lov-code": "STOCK.INPUT_STATUS" },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockEntryInform.header.receivingLogicWarehouseCode"
                          ),
                          prop: "receivingLogicWarehouseCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessStockEntryInform.header.receivingLogicWarehouseCodeText"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.receivingLogicWarehouseCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "receivingLogicWarehouseCode",
                                $$v
                              )
                            },
                            expression:
                              "queryParams.receivingLogicWarehouseCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockEntryInform.header.beginCreationDate"
                          ),
                          prop: "beginCreationDate",
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockEntryInform.header.beginCreationDate"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    [
                                      "code",
                                      "platformOrderCode",
                                      "orderCode",
                                    ].includes(col.prop)
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "link",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onView(
                                                      scope.row,
                                                      col.prop
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row[col.prop])
                                                ),
                                              ]
                                            ),
                                            _c("BjCopyIcon", {
                                              staticClass: "ml10",
                                              attrs: {
                                                copy: scope.row[col.prop],
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.STOCK_INPUT_STATUS.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                          ),
                                        ]
                                      : col.prop === "inputTypeMeaning"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.STOCK_INPUT_TYPE.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              )
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }